export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="font-display text-4xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-muted text-sm mb-10">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="space-y-8 text-sm leading-relaxed text-muted">
        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">1. Data We Collect</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Email address (for account and receipt delivery)</li>
            <li>Password (stored as a bcrypt hash, never in plaintext)</li>
            <li>Hardware identifiers (disk, CPU, GPU serial numbers, hashed for HWID binding)</li>
            <li>IP address (for security logging and abuse prevention)</li>
            <li>Payment metadata (processed by Stripe; we do not store card details)</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">2. How We Use Your Data</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>To authenticate your account and license</li>
            <li>To verify your hardware binding</li>
            <li>To send purchase receipts and password reset emails</li>
            <li>To prevent fraud, account sharing, and abuse</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">3. Data Storage</h2>
          <p>
            Your data is stored on Cloudflare infrastructure (D1 database, R2 object storage). All
            passwords are hashed using bcrypt. Hardware identifiers are stored as SHA-256 hashes.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">4. Payment Processing</h2>
          <p>
            Payments are processed by Stripe. We do not collect or store your credit card
            information. Stripe's privacy policy applies to all payment data.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">5. Data Sharing</h2>
          <p>
            We do not sell or share your data with third parties, except as required by law or to
            process payments via Stripe.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">6. Data Retention</h2>
          <p>
            We retain your account and license data for as long as your license is active. Hardware
            binding history is retained for abuse prevention.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">7. Your Rights</h2>
          <p>
            You may request deletion of your account data at any time. Note that this will also
            deactivate your license.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">8. Cookies</h2>
          <p>
            We use a single HTTP-only cookie for session authentication. We do not use tracking or
            analytics cookies.
          </p>
        </section>

        <section>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">9. Contact</h2>
          <p>For privacy questions, contact us via the support channels available on this site.</p>
        </section>
      </div>
    </div>
  );
}
